import { useState } from "react";
import { motion } from "framer-motion";

import { serviceItems, trainingItems } from "./Data";
import ContentSection from "./ContentSection";

const AcademicAndService = () => {
  const [activeTrainingId, setActiveTrainingId] = useState(
    trainingItems[0]?.id || null
  );
  const [activeServiceId, setActiveServiceId] = useState(
    serviceItems[0]?.id || null
  );

  return (
    <>
      <main className="font-sans bg-slate-100">
        <section
          aria-labelledby="section-heading"
          className="relative px-2 py-8 sm:px-6 lg:px-8 w-full min-h-fit overflow-x-hidden"
        >
          <div className="container mx-auto max-w-screen-xl space-y-2 md:space-y-4 relative z-10">
            <div className="flex flex-col justify-center items-center text-center relative">
              <motion.header
                className="max-w-4xl mx-auto"
                initial="hidden"
                animate="visible"
              >
                <motion.h2
                  id="section-heading"
                  className="text-4xl md:text-5xl font-extrabold text-slate-800 tracking-tight"
                >
                  <motion.span className="inline-block mr-4">
                    <h2 className="text-3xl sm:text-4xl lg:text-4xl font-extrabold text-slate-700 tracking-tight">
                      Our {" "}
                      <span className="relative inline-block">
                        <span className="absolute inset-0 bg-sky-200/50 -skew-y-2 transform rounded-lg"></span>
                        <span className="relative text-sky-600">Academies</span>
                      </span>
                      {" "}
                      & {" "}
                      <span className="relative inline-block">
                        <span className="absolute inset-0 bg-sky-200/50 -skew-y-2 transform rounded-lg"></span>
                        <span className="relative text-sky-600">Services</span>
                      </span>{" "}
                    </h2>
                  </motion.span>
                </motion.h2>
                <motion.p className="text-xl text-slate-600 mt-6 max-w-3xl mx-auto">
                  Explore our expert-led training courses and professional drone
                  services, tailored to meet the highest industry standards.
                </motion.p>
              </motion.header>
            </div>

            <ContentSection
              id="training"
              title="Training & Certification"
              items={trainingItems}
              activeId={activeTrainingId}
              setActiveId={setActiveTrainingId}
              theme="blue"
              layout="split"
            />

            <ContentSection
              id="services"
              title="Drone as a Service (DaaS)"
              items={serviceItems}
              activeId={activeServiceId}
              setActiveId={setActiveServiceId}
              theme="green"
              layout="hero"
            />
          </div>
        </section>
      </main>
    </>
  );
};

export default AcademicAndService;
